<template>
  <div>
    <div
      v-if="loading || properties.length === 0"
      class="position-relative"
      style="background-color: white; border-radius: 0.626rem"
    >
      <div style="opacity: 0">
        <invadobay-property-card
          :property="{
            thumbnail_url: '/assets/images/common/statics/room_placeholder.png',
            name: '---',
          }"
          :card="{
            image_style: {
              'min-height': '200px',
            },
          }"
          :checkin="moment()"
          :checkout="moment()"
          is_placeholder
        />
      </div>
      <div v-if="loading" class="position-absolute" style="top: 50%; left: 50%">
        <loader />
      </div>
      <div
        v-else
        class="position-absolute"
        style="top: 50%; text-align: center; width: 100%"
      >
        <div>Nessuna proposta</div>
      </div>
    </div>
    <swiper
      v-else
      :ref_id="`property_container:${invadobay.id}`"
      :swiper_params="{ button_offset: 15, loop: true }"
    >
      <template>
        <swiper-slide
          v-for="property in properties"
          :key="`property:${invadobay.id}:${property.id || property.name}`"
          class="px-2 pb-lg-0 pb-2"
        >
          <invadobay-property-card
            :property="property"
            v-bind="get_suggested_booking_dates(invadobay)"
            :card="{
              image_style: {
                'min-height': '200px',
              },
            }"
          />
        </swiper-slide>
      </template>
    </swiper>
  </div>
</template>

<script>
import { get_suggested_booking_dates } from "@liveeps/utilities";
import moment from "moment";
import Swiper from "@/components/blocks/swiper.vue";
import InvadobayPropertyCard from "./invadobay-property-card.vue";

export default {
  name: "invadobay-search-preview-properties",
  components: {
    swiper: Swiper,
    "invadobay-property-card": InvadobayPropertyCard,
  },
  props: {
    loading: Boolean,
    properties: Array,
    invadobay: Object,
  },
  methods: {
    moment,
    get_suggested_booking_dates,
  },
};
</script>

<style lang="scss" scoped></style>
